import { SummariesTab as Component } from './component';
import Connector from './connector';
import { ConnectorProps } from './SummariesTab.proptypes';

export interface SummariesTabProps extends Omit<ConnectorProps, 'component'> {}

export const SummariesTab = () => <Connector component={Component} />;
